export const shouldShowGoogleAdsContactUs = ({
  segmentSyncOff,
  adIntegrationOff,
  hasEcModule,
}: {
  segmentSyncOff: boolean;
  adIntegrationOff: boolean;
  hasEcModule: boolean;
}): boolean => segmentSyncOff && adIntegrationOff && !hasEcModule;

export const shouldShowMetaAdsContactUs = ({
  adIntegrationOff,
}: {
  adIntegrationOff: boolean;
}): boolean => adIntegrationOff;
